import { apiFetch } from "../useApi";

export default async function getCampaigns({ queryKey }) {
  const [, campaignType] = queryKey;

  const response = await apiFetch(`/campaigns?type=${campaignType}`);
  return response.json();
}
